export const pushEvent = (eventObject: object) => {
    (window as any).dataLayer = (window as any).dataLayer || [];
    (window as any).dataLayer.push(eventObject);
}